import { RootAppState } from 'store/configureStore'

export const projectInBuyerViewSelector = (state: RootAppState) => {
  return state.project?.activeProject?.isBuyingPartyView
}
